import styles from './index.module.scss';
import { LoadingPlaceholder } from '../../../components/LoadingPlaceholder';
import ClinicalEvents from '../ClinicalEvents';
import MobileReportedEvents from './MobileReportedEvents';
import { isMobile } from 'react-device-detect';

const ReportedEvents = ({ isLoading }: { isLoading: boolean }) => {
  return (
    <LoadingPlaceholder isLoading={isLoading}>
      <div className={styles.root}>
        {isMobile ? <MobileReportedEvents /> : <ClinicalEvents />}
      </div>
    </LoadingPlaceholder>
  );
};

export default ReportedEvents;
